/* eslint-disable */
import { getLogger } from './../logger';

const logger = getLogger('network_appender');
const lpTag = window.lpTag || {};

function doLog(logData = { msg: 'test' }) {
  if (window.LE && window.LE.getConfig && window.LE.sessionManager) {
    const url = `https://${window.LE.getConfig().loggos}/api/loggos/log/?accountId=${window.LE.sessionManager.accountId}&appName=CCUIInfra`;
    logData = {
      ...logData,
      module_url: window.location.href,
      accountId: window.LE.getConfig().accountId,
      userId: window.LE.sessionManager.getUserId(),
    };

    lpTag.taglets.lpAjax.issueCall({
      transportOrder: ['postmessage'],
      url,
      data: logData,
      method: 'POST',
      headers: {
        AUTHORIZATION: `Bearer ${window.LE.sessionManager.getGlob()}`,
      },
      success(data) {
      },
      error(e) {
        try {
          logger.error('Network Error Logger: failed to request loggos', e);
        } catch (ex) {
          console.error('Network Error Logger: Error executing logger in doLog', ex1);
        }
      },
    });
  }
}

export function registerNetworkLogger() {
  let realSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (request) {
    try {
      this.addEventListener('readystatechange', function() {
        if (this.readyState === 4) {
          if (this.status >= 400 && this.responseURL && this.responseURL.indexOf('loggos/log/') === -1) {
            doLog(
            {
              msg: 'network_error',
              api_url: this.responseURL,
              method: this.method,
              status: this.status,
              request: this.requestData,
              response: this.responseText,
              logLevel: 'metrics',
            });
          }
        }
      }, false);
    }
    catch (ex) {
      try {
        logger.error('Network Error Logger - Global exception', ex);
      } catch (ex1) {
        console.error('Network Error Logger - Error executing logger', ex1);
      }
    }
    finally {
      realSend.apply(this, arguments);
    }
  };
}




// WEBPACK FOOTER //
// ./src/logger/appenders/NetworkAppender.js